import React from 'react';
import styled from 'styled-components';

import SVG  from 'react-inlinesvg';

export const Svg = styled(SVG).attrs({
    className: 'icon',
    preloader: (<span className="preload" />),
    src: ({ name }) => `./static/svg/${name}.svg`
})`
  display: inline-block;
  margin-right: .2em;
  line-height: 1em;
  margin-left: .2em;

  .preload,
  svg {
    width: 1em;
    height: 1em;
    display: block;
  }

  path, g {
    fill: currentColor;
  }
`;
